import { InsightsConsumption } from "./insights-consumption.types";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export function InsightsConsumptionTimeline({
  data,
  type,
}: {
  data: InsightsConsumption;
  type: "danger" | "default" | "good" | "warning";
}) {
  const [translate] = useTranslation(["dashboard-charts"]);

  return (
    <div className="flex items-start">
      <div className="flex flex-col items-center mr-3">
        <div
          className={`w-4 h-4 border-2 relative ${type === "danger" ? "border-red-600" : type === "warning" ? "border-orange-500" : "border-sky-600"} rounded-full`}
        >
          <div
            className={`w-1 h-1 ${type === "danger" ? "bg-red-600" : type === "warning" ? "bg-orange-500" : "bg-sky-600"} rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
          />
        </div>
        <div
          className={`w-[1px] h-[12px] ${type === "danger" ? "bg-red-600" : type === "warning" ? "bg-orange-500" : "bg-sky-600"} my-[2px]`}
        />
        <div
          className={`w-4 h-4 ${type === "danger" ? "bg-red-600" : type === "warning" ? "bg-orange-500" : "bg-sky-600"} rounded-full`}
        />
      </div>
      <div>
        <p
          className={`text-sm ${type === "danger" ? "text-red-600" : type === "warning" ? "text-orange-500" : "text-sky-600"}`}
        >
          {dayjs().format("MMMM")}:{" "}
          <span className="font-bold">{data.current}</span>{" "}
          {translate("dashboard-credits-label-text")}
        </p>
        <p className="text-sm text-muted-foreground mt-3">
          {translate("dashboard-consumption-average")}:{" "}
          <span className="font-bold">{data.average}</span>{" "}
          {translate("dashboard-credits-label-text")}
        </p>
      </div>
    </div>
  );
}
